<template>
    <div class='zbhxr' v-if='kbxmlc'>
       <div :class='["box",kbxmlc.zt=="2"||role!="Z"?"noBtn":""]'>
            <div class="clear">
                <p class="cont-title lf">中标候选人</p>
                <div class="rt">
                    <el-input v-model="tbdwmc" class="input-with-select lf" style="width:250px;margin:0 10px" placeholder="投标单位名称">
                        <el-button slot="append" icon="el-icon-search" @click='serachData'></el-button>
                    </el-input>
                    <template v-if='role=="Z"'>
                        <el-button type="primary" @click="saveZbhxr" :disabled="hasJg==0||kbxmlc.zt=='2'||waitLoading">确定</el-button>
                    </template>
                    <el-button type="primary"  :disabled="!isOk||waitLoading" @click='dcZbhxr'>下载报表</el-button>
                </div>
            </div>
            <el-table
                ref="table"
                border
                :data="tableData"
                style="width: 100%"
            >
                <el-table-column type="index" label="序号" width="60">
                <template slot-scope="scope">{{(currentPage - 1) * pageSize + scope.$index + 1}}</template>
                </el-table-column>
                <el-table-column prop="fCQYMC" label="投标单位名称" show-overflow-tooltip min-width="200"></el-table-column>
                <el-table-column :prop="val" :label="key" width="150" v-for='(val,key,index) in tableHead' :key='index' show-overflow-tooltip></el-table-column>
                <el-table-column prop="pm" label="排名" width="180"></el-table-column>
                <el-table-column prop="zbhxr" label="中标候选人" width="200">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.zbhxr" v-if='kbxmlc.zt!="2"&&role=="Z"' @change='qdzbhxr(scope.row.zbhxr,scope.row.id)'>
                            <el-option v-for='item in options' :key='item.id' :label='item.label' :value='item.id' :disabled="jgArr[item.id]!=null"></el-option>
                        </el-select>
                        <template v-else>
                            {{scope.row.zbhxr==1?'第一中标候选人':''}}
                            {{scope.row.zbhxr==2?'第二中标候选人':''}}
                            {{scope.row.zbhxr==3?'第三中标候选人':''}}
                        </template>
                    </template>
                </el-table-column>
            </el-table>
            <div class="clear">
                <span class="lf pageNum">共{{total}}家，已设置中标候选人{{zbhxrNum}}家。</span>
                <myPage
                class="rt"
                :total="total"
                :page-size="pageSize"
                :currentPage="currentPage"
                @changePage="changePage"
                ></myPage>
            </div>
        </div>
        <el-button type="primary lcNext" :disabled="!isOk||waitLoading"  @click="nextBtn" v-if="kbxmlc.zt!='2'&&role=='Z'">开标结束</el-button>
    </div>
    <div v-else class='loading'>
        <p>页面正在加载中...</p>
        <div id="colorfulPulse">
            <span class='item-1'></span>
            <span class='item-2'></span>
            <span class='item-3'></span>
            <span class='item-4'></span>
            <span class='item-5'></span>
            <span class='item-6'></span>
            <span class='item-7'></span>
        </div>
    </div>
</template>
<script>
import myPage from '../components/page'
export default {
    name:'zbhxr',
    components:{
        myPage
    },
    data(){
        return{
            waitLoading:false,
            kbxmlc:'',
            djlcId: "", //当前节点状态
            tableHead:{},
            tableData: [],
            zbhxrNum: 0,
            tbdwmc: "",
            currentPage: 1,
            total: 0,
            pageSize: 10,
            jgArr:[null,null,null,null],//中标候选人结果
            hasJg:0,//选择候选人的个数
            isOk:false,//是否提交保存过中标候选人
            options:[{label:'请选择',id:0},{label:'第一中标候选人',id:1},{label:'第二中标候选人',id:2},{label:'第三中标候选人',id:3}],
            role:localStorage.getItem('role')?localStorage.getItem('role'):'T',
        }
    },
    methods:{
        getData(){
            let para={
                currentPage:this.currentPage,
                pageSize:this.pageSize,
                tbdwmc:this.tbdwmc,
                djlcId:this.djlcId
            }
            this.waitLoading=true
            this.$api.zbhxrList(para).then(res=>{
                if(res.data.meta.success){
                    this.tableHead=res.data.data.bjxsmc;
                    this.total=res.data.data.total;
                    this.kbxmlc=res.data.data.kbxmlc;
                    if(res.data.data.tbdwMap){
                        var arr=res.data.data.tbdwList;
                        arr.forEach((item,index)=>{
                            for(let key in res.data.data.tbdwMap[item.id]){
                                item[key]=res.data.data.tbdwMap[item.id][key]
                            }
                        })
                        this.tableData=arr;
                    }else{
                        this.tableData=res.data.data.tbdwList;
                    }
                    this.zbhxrNum=res.data.data.zbhxrSize
                    this.isOk=res.data.data.sfszzbhxr;
                    if(res.data.data.zbhxrXzJson){
                        for(let key in res.data.data.zbhxrXzJson){
                            let index=res.data.data.zbhxrXzJson[key]
                            this.jgArr[index]=key;
                            this.hasJg++
                        }
                    }
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.mesage
                    })
                }
                this.waitLoading=false
            }).catch(()=>{})
        },
        serachData(){
            this.currentPage=1;
            this.getData();
        },
        //选择中标候选人
        qdzbhxr(i,id){
            if(i!=0){
                let index=this.jgArr.findIndex((b,index,arr)=>{
                    return b==id
                })
                if(index>0){
                    this.jgArr[index]=null;
                }else{
                    this.hasJg++
                }
                this.jgArr[i]=id;
            }else{
                var _index
                this.tableData.forEach(a=>{
                    if(a.id==id){
                        this.jgArr.forEach((b,index)=>{
                            if(b==id){
                                this.jgArr[index]=null;
                                this.hasJg--
                            }
                        })
                    }
                    
                })
            }
        },
        //开启确认
        saveZbhxr(){
            this.waitLoading=true
            let para=Object.assign({},this.jgArr);
            this.$api.saveZbhxr(para).then(res=>{
                if(res.data.meta.success){
                    this.$message({
                        type:'success',
                        message:'保存成功！'
                    })
                    this.getData();
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.mesage
                    })
                }
                this.waitLoading=false
            }).catch(()=>{})
        },    
        dcZbhxr(){
            let para={}
            this.waitLoading=true
            this.$api.dcZbhxr(para).then(res=>{
                let fileName = decodeURI(res.headers["content-disposition"].split("=")[1]);
                let blob = new Blob([res.data])
                if (window.navigator.msSaveOrOpenBlob) {
                    navigator.msSaveBlob(blob, fileName)
                } else {
                    var link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = fileName
                    link.click()
                    //释放内存
                    window.URL.revokeObjectURL(link.href)
                }
                this.waitLoading=false
            }).catch(()=>{})
        },   
        changePage(page){
            this.currentPage=page;
            this.getData();
        },
        nextBtn() {
             let para = {
                flag:this.kbxmlc.ycdz,
                isOver:true
            };
            this.waitLoading=true
            this.$emit("nextBtn", para);

        }
    },
    mounted(){
        this.djlcId = this.$route.query.djlcId;
        this.getData();
    }
}
</script>
<style lang="less">
.zbhxr{
    td{
        .el-input__inner,.el-input__icon{
            height: 29px;
            line-height: 29px;
        }
    }
}
</style>